import React, { Fragment } from "react";

import { Box, Container, Flex, Wrapper } from "../../style/Grid";
import { SiteNav, SiteNavLogo, SiteNavLink, FooterTopWrapper, FooterHeading, FooterList, FooterListItem } from "../../style/Footer";
import { contact, kapitolSites, URLS } from "../../const/const";
import Link from "../Link";
import { Text } from "../../style/Text";
import Icon from "../../style/Icon";
import { Image } from "../../style/Image";
import { Button } from "../../style/Button";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import { KrystufekLogo } from "../../assets/Svg";

const Footer = () => (
  <Fragment>
    <FooterTopWrapper>
      <Container display="flex">
        <Flex flexDirection="column" pt="23px" pb="3" width={"100%"}>
          <Flex flexWrap="wrap" justifyContent={"space-between"} position={"relative"}>
            <Flex
              flexDirection={"column"}
              justifyContent={"space-between"}
              width={["100%", "60%", null, null, "405px"]}
              pr={[null, "20px", null, null, null]}
              pb={[4, 3, null, null, "0"]}
            >
              <FooterHeading>Kontaktujte nás</FooterHeading>

              <Flex flexDirection="column">
                <Flex as="p" mt="0" lineHeight={"36px"} alignItems="center">
                  <Icon icon="phone" size={21} mr={12} />
                  <Link href={`tel:${contact.phoneLink}`} fontSize={3} fontWeight="light" mr={2} color="white.100">
                    <span dangerouslySetInnerHTML={{ __html: contact.phone }} />
                  </Link>
                  <Text as="span" fontSize={0} lineHeight={"28px"} mb={"auto"} color="footer.link">
                    Po&ndash;Pá&nbsp;8:00&ndash;16.00
                  </Text>
                </Flex>

                <Flex as="p" mt="0" mb={[3, null, null, 4]} lineHeight={"36px"} alignItems="center">
                  <Icon icon="mail" size={24} mr={11} color="cta" />
                  <Link variant="footerEmail" as="a" href={`mailto:${contact.mail}`} style={{ textTransform: "uppercase" }}>
                    {contact.mail}
                  </Link>
                </Flex>
              </Flex>

              <Text as="address" color="footer.link" fontSize={0} alignSelf="flex-end" fontStyle="normal">
                KAPITOL,&nbsp;a.s.
                <br />
                Vlněna&nbsp;526/3, Trnitá,&nbsp;Brno, 602&nbsp;00
                <br />
                IČ:&nbsp;60751070, DIČ:&nbsp;CZ699000955
              </Text>
            </Flex>

            <Box
              width={["100%", "40%", null, null, "305px"]}
              pl={[null, "20px", null, null, "0"]}
              pr={[null, null, null, null, "20px"]}
              pb={[6]}
              position={"relative"}
            >
              <FooterHeading>Důležité odkazy</FooterHeading>

              <FooterList>
                <FooterListItem>
                  <Link href={URLS.gdpr}>GDPR – zásady zpracování osobních údajů</Link>
                </FooterListItem>
                <FooterListItem>
                  <Link href={URLS.complaintsProcedure}>Reklamační řád</Link>
                </FooterListItem>
                <FooterListItem>
                  <Link href={URLS.whistleblowing}>Whistleblowing</Link>
                </FooterListItem>
                <FooterListItem>
                  <Link href={URLS.cookies}>O Cookies</Link>
                </FooterListItem>
                <FooterListItem>
                  <a onClick={() => Cookiebot.renew()}>Nastavení cookies</a>
                </FooterListItem>
                <FooterListItem>
                  <Link href={URLS.ethicalCode}>Etický kodex</Link>
                </FooterListItem>
              </FooterList>

              <Flex position={"absolute"} bottom={0} left={0} width={"150%"} display={["none", null, null, null, "block"]}>
                <Text mt={[3, null, null, null, 0]} as="p" color="footer.link" fontSize={0}>
                  &copy; {new Date().getFullYear()} KAPITOL, Všechna příslušná práva vyhrazena
                </Text>
              </Flex>
            </Box>

            <Box width={["100%", "60%", null, null, "305px"]} pr={[null, "20px", null, null, null]} pb={[4, 3, null, null, 0]}>
              <FooterHeading>Povinně zveřejňované informace</FooterHeading>

              <FooterList>
                <FooterListItem>
                  <Link href={`${URLS.mandatoryInformationPrefix}-zivotni-pojisteni/`}>Životní pojištění</Link>
                </FooterListItem>
                <FooterListItem>
                  <Link href={`${URLS.mandatoryInformationPrefix}-nezivotni-pojisteni/`}>Neživotní pojištění</Link>
                </FooterListItem>
                <FooterListItem>
                  <Link href={`${URLS.mandatoryInformationPrefix}-investice/`}>Investice</Link>
                </FooterListItem>
                <FooterListItem>
                  <Link href={`${URLS.mandatoryInformationPrefix}-doplnkove-penzijni-sporeni/`}>Doplňkové penzijní spoření</Link>
                </FooterListItem>
                <FooterListItem>
                  <Link href={`${URLS.consumerLoansFile}`}>Spotřebitelské úvěry</Link>
                </FooterListItem>
                <FooterListItem>
                  <Link href={URLS.ESGInsurance}>Informace o udržitelném financování (ESG) v oblasti pojišťovacího poradenství</Link>
                </FooterListItem>
              </FooterList>
            </Box>

            <Flex
              flexDirection={["row", "column"]}
              justifyContent={"space-between"}
              width={["100%", "40%", null, null, "155px"]}
              pl={[null, "20px", null, null, "0"]}
              pb={[38, 3, null, null, "0"]}
            >
              <Box>
                <FooterHeading>Buďme ve spojení</FooterHeading>

                <FooterList>
                  <FooterListItem withIcon>
                    <Icon icon="linkedin" color="footer.link" size={18} mr={2} />
                    <Link href={URLS.linked}>Linkedin</Link>
                  </FooterListItem>
                  <FooterListItem withIcon>
                    <Icon icon="facebook" color="footer.link" size={18} mr={2} />
                    <Link href={URLS.fb}>Facebook</Link>
                  </FooterListItem>
                  <FooterListItem withIcon>
                    <Icon icon="instagram" color="footer.link" size={18} mr={2} />
                    <Link href={URLS.instagram}>Instagram</Link>
                  </FooterListItem>
                  <FooterListItem withIcon>
                    <Icon icon="youtube" color="footer.link" size={18} mr={2} />
                    <Link href={URLS.yt}>Youtube</Link>
                  </FooterListItem>
                </FooterList>
              </Box>

              <Link href={URLS.christopherFoundation} mr={["9vw", 0]} mt={[40, 16]} display={"flex"}>
                <Image alt={"Kryšřůfek"} src={KrystufekLogo} width={100} />
              </Link>
            </Flex>
            <Flex display={["block", null, null, null, "none"]}>
              <Text mt={0} as="p" color="footer.link" fontSize={0}>
                &copy; {new Date().getFullYear()} KAPITOL, Všechna příslušná práva vyhrazena
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Container>
    </FooterTopWrapper>

    <Wrapper backgroundColor="#003d50">
      <Container position="relative" alignItems={"center"}>
        <SiteNavLogo src={"/image/kapitol-icon.png"} />
        <SiteNav>
          {kapitolSites.map((site, index) => (
            <li key={index}>
              <SiteNavLink as={Link} target="_blank" href={site.url} active={site.active ? 1 : 0}>
                {site.label}
              </SiteNavLink>
            </li>
          ))}
        </SiteNav>
      </Container>
    </Wrapper>
  </Fragment>
);

export default Footer;
